import { Box, Container, Heading, Text, Stack, Circle } from "@chakra-ui/react";

const RoadmapItem = ({
  phase,
  title,
  items,
}: {
  phase: string;
  title: string;
  items: string[];
}) => {
  return (
    <Stack
      spacing={4}
      p={6}
      bg="oxygon.dark.200"
      rounded="xl"
      border="1px solid"
      borderColor="oxygon.dark.300"
      _hover={{
        borderColor: "oxygon.primary",
        transform: "translateY(-5px)",
      }}
      transition="all 0.3s"
      data-aos="fade-up"
    >
      <Stack direction="row" align="center" spacing={4}>
        <Circle
          size="40px"
          bg="oxygon.secondary"
          color="white"
          fontWeight="bold"
          fontSize="sm"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {phase}
        </Circle>
        <Heading size="md">{title}</Heading>
      </Stack>
      <Stack spacing={3}>
        {items.map((item, index) => (
          <Stack key={index} direction="row" spacing={3} align="center">
            <Box
              w="4px"
              h="4px"
              bg="oxygon.primary"
              rounded="full"
              flexShrink={0}
              mt={1}
            />
            <Text color="gray.400">{item}</Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

const Roadmap = () => {
  const roadmapData = [
    {
      phase: "01",
      title: "Bring sim golfers together",
      items: [
        "Unite simulator golfers regardless of background, tech, or software",
        "Create one place where people share their love for simulator golf",
      ],
    },
    {
      phase: "02",
      title: "Become the leading platform",
      items: [
        "Build the leading simulator golf platform across the world",
        "Connect communities, venues, schools, and friends under one identity",
      ],
    },
    {
      phase: "03",
      title: "Grow simulator golf into a major sport",
      items: [
        "Help turn simulator golf into one of the biggest sports in the world",
        "Make it easier to discover, join, and participate in the global sim golf community",
      ],
    },
    {
      phase: "04",
      title: "Everyone is welcome",
      items: [
        "From children to retirees, everyone has a place in VGS",
        "Create an inclusive community where all simulator golfers can belong",
      ],
    },
  ];

  return (
    <Box py={20} bg="oxygon.dark.100">
      <Container maxW="container.xl">
        <Stack spacing={12}>
          <Stack textAlign="center" spacing={4} data-aos="fade-up">
            <Heading
              bgGradient="linear(to-r, oxygon.primary, oxygon.secondary)"
              bgClip="text"
            >
              The Goal of VGS
            </Heading>
            <Text color="gray.400" maxW="800px" mx="auto">
              Bring all sim golfers together — regardless of background, tech,
              or software — into one place where they share their love for
              simulator golf. VGS aims to be the leading platform worldwide and
              help turn simulator golf into one of the biggest sports in the
              world.
            </Text>
          </Stack>

          <Stack spacing={8}>
            {roadmapData.map((phase, index) => (
              <RoadmapItem
                key={index}
                phase={phase.phase}
                title={phase.title}
                items={phase.items}
              />
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Roadmap;
